import { Platform, ToastAndroid } from 'react-native';

import { AppSnackbar, type SnackbarType } from './AppSnackbar';

type ToastOptions = {
  durationMs?: number;
};

export function showToast(
  message: string,
  type: SnackbarType = 'info',
  options?: ToastOptions,
) {
  if (Platform.OS === 'android') {
    ToastAndroid.show(message, ToastAndroid.SHORT);
    return;
  }

  AppSnackbar.show(message, type, { durationMs: options?.durationMs ?? 2500 });
}

export function showComingSoonToast() {
  showToast('This feature is coming soon');
}
